﻿import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Patient } from '../_models';
import { config } from '../../assets/config';
import {getToken} from '../../assets/utils.js';

@Injectable()
export class PatientService {
    constructor(private http: HttpClient) {}

    getAll() {
        return this.http.get<Patient[]>(`${config.apiUrl}/patients`);
    }

    getById(id: string) {
        return this.http.get(`${config.apiUrl}/patients/` + id);
    }

    getByUserId(id: string, archived: boolean = false) {
        return this.http.get(`${config.apiUrl}//patients?filter={"where":{"archived":${archived},"userId":{"like":"${id}"}}}&access_token: ${getToken()}`);
    }

    register(patient: Patient) {
        return this.http.post(`${config.apiUrl}/patients/register`, patient, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    registerByUserId(userId: string, patient: Patient) {
        patient.userId = userId;
        return this.http.post(`${config.apiUrl}/patients/`, patient, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    update(patient: Patient) {
        return this.http.patch(`${config.apiUrl}/patients/` + patient.id, patient, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    archive(id: string, archived: boolean = true) {
        const data = {
            archived
        }
        return this.http.patch(
            `${config.apiUrl}/patients/` + id,
            data,
            {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
            }
        );
    }

    delete(id: string) {
        return this.http.delete(`${config.apiUrl}/patients/` + id);
    }
}
